import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.e1{background:var(--palette-white);}.ssr-plugin'
import '.ad{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.gr{justify-content:stretch;}.ssr-plugin'
import '.b8{position:sticky;}.ssr-plugin'
import '.b9{top:0px;}.ssr-plugin'
import '.bd{z-index:10;}.ssr-plugin'
import '.fy{padding-block:1rem;}.ssr-plugin'
import '.fz{height:3rem;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.gs{margin-bottom:0px;}.ssr-plugin'
import '.gt{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fv{margin-top:2rem;}.ssr-plugin'
import '.gu{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d r ai e e1"
      >
        <div className="ad d t ai e"
        >
          <div className="ab d e gr b8 b9 bd e1"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fy fz d ao t ar"
            >
              <styled.span className="gs"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gt d e r fv gu ab"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
